import React, { Component } from "react";
import { Formik } from "formik";
import {
	Navbar,
	Nav,
	NavDropdown,
	Form,
	Button,
	Row,
	Col,
	Jumbotron,
	Table,
	Tr,
	Td,
	Pagination,
} from "react-bootstrap";
import { NavAdmin } from "components/nav/NavAdmin";
import * as config from "config/config";

/*CSS*/
import "../../../../asset/css/add.css";

class ModifyClient extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formatEtiquettes: [],
			profil: [],
			casUPS: [],
			serviceCode: [],
			client: {},
			agences: [],
			data: [],
		};
	}
	componentDidMount() {
		config
			.apiFetch(config.Api_Url + "/clients/formatEtiquettes/")
			.then((response) => response.json())
			.then((data) => {
				let formatEtiquettes = [];
				for (let number = 0; number < data["data"].length; number++) {
					formatEtiquettes.push(
						<option key={"option_formatEtiquettes_" + number}>
							{data["data"][number]["formatEtiquettes"]}
						</option>
					);
				}
				this.setState({
					formatEtiquettes: [formatEtiquettes],
				});
			});
		config
			.apiFetch(config.Api_Url + "/clients/profil/")
			.then((response) => response.json())
			.then((data) => {
				let profil = [];
				for (let number = 0; number < data["data"].length; number++) {
					profil.push(
						<option
							key={"option_profil_" + number}
							value={data["data"][number]["nom"]}
						>
							{data["data"][number]["nom"]}
						</option>
					);
				}
				this.setState({
					profil: [profil],
				});
			});
		config
			.apiFetch(config.Api_Url + "/clients/casUPS/")
			.then((response) => response.json())
			.then((data) => {
				let casUPS = [];
				for (let number = 0; number < data["data"].length; number++) {
					casUPS.push(
						<option key={"option_casUPS_" + number}>
							{data["data"][number]["casUPS"]}
						</option>
					);
				}
				this.setState({
					casUPS: [casUPS],
				});
			});
		config
			.apiFetch(config.Api_Url + "/clients/serviceCode/")
			.then((response) => response.json())
			.then((data) => {
				let serviceCode = [];
				for (let number = 0; number < data["data"].length; number++) {
					serviceCode.push(
						<option key={"option_serviceCode_" + number}>
							{data["data"][number]["serviceCode"]}
						</option>
					);
				}
				this.setState({
					serviceCode: [serviceCode],
				});
			});
		config
			.apiFetch(
				config.Api_Url + "/findbyidAdmin/client/" + this.props.match.params.id
			)
			.then((response) => response.json())
			.then((data) => {
				if (data["data"].length != 0) {
					this.setState({
						client: data["data"][0],
					});
				} else {
					this.props.history.push("/404");
				}
			});
		/*AGENCE AREA */
		let user_role = JSON.parse(localStorage.getItem("currentUser"))["data"][0]
			.aut_role;
		let user_id = JSON.parse(localStorage.getItem("currentUser"))["data"][0]
			.aut_id;
		//IF ADMIN, we provide agence modify
		//If not we set agence by defaut of the account
		if (user_role == "Admin") {
			config
				.apiFetch("/agences")
				.then((response) => response.json())
				.then((data) => {
					let agences = [];
					for (let number = 0; number < data["data"].length; number++) {
						agences.push(
							<option
								key={"option_agences_" + number}
								value={data["data"][number]["agence_id"]}
							>
								{data["data"][number]["agence_name"]}
							</option>
						);
					}
					this.setState({
						agences: [agences],
					});
				});
		} else {
			config
				.apiFetch("/getAgenceByAccount/" + user_id)
				.then((response) => response.json())
				.then((data) => {
					this.setState({
						data: data["data"][0],
					});
				});
		}
	}
	render() {
		let user_role = JSON.parse(localStorage.getItem("currentUser"))["data"][0]
			.aut_role;
		return (
			<div>
				<NavAdmin />
				<div className="container">
					<Row className="justify-content-center">
						<Col md={6}>
							<h1>Modifier le client</h1>
							<Formik
								initialValues={this.state.client}
								enableReinitialize
								onSubmit={(values, { setSubmitting }) => {
									config
										.apiFetch(config.Api_Url + "/update/clients", {
											method: "POST",
											body: JSON.stringify({
												id_client: this.props.match.params.id,
												id_clientParent:
													values.id_clientParent != ""
														? values.id_clientParent
														: 0,
												vchNumFacturation: values.vchNumFacturation,
												nom: values.nom,
												prenom: values.prenom,
												login: values.login,
												password: values.password,
												adresse: values.adresse,
												codepostal: values.codepostal,
												ville: values.ville,
												telephone: values.telephone,
												fax: values.fax,
												mail: values.mail,
												profession: values.profession,
												profil: values.profil,
												active: values.active,
												formatEtiquettes: values.formatEtiquettes,
												heureLimite:
													values.heureLimite != ""
														? values.heureLimite
														: "NULL",
												casUPS: values.casUPS || 0,
												nomPoint: values.nomPoint != "" ? values.nomPoint : "",
												adressePoint: values.adressePoint
													? values.adressePoint
													: "",
												heurePoint:
													values.heurePoint != "" ? values.heurePoint : "NULL",
												serviceCode: values.serviceCode,
												agence:
													user_role == "Admin"
														? values.agence
															? values.agence
															: "NULL"
														: this.state.data.agence_id,
											}),
											headers: { "Content-Type": "application/json" },
										})
										.then((response) => response.json())
										.then((data) => {
											if ("data" in data) {
												window.location.reload();
											} else {
												alert(
													"Il y a une erreur ou ce couple identifiant/mot de passe existe déjà"
												);
											}
										});
								}}
							>
								{({
									values,
									errors,
									touched,
									handleChange,
									handleBlur,
									handleSubmit,
									isSubmitting,
									/* and other goodies */
								}) => (
									<Form onSubmit={handleSubmit}>
										<Form.Label className="required">Nom</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="nom"
											value={values.nom || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">Prénom :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="prenom"
											value={values.prenom || ""}
											onChange={handleChange}
										/>
										<Form.Label>Numéro Facturation :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="vchNumFacturation"
											value={values.vchNumFacturation || ""}
											onChange={handleChange}
										/>
										<Form.Label>Compte parent :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="id_clientParent"
											value={values.id_clientParent || ""}
											onChange={handleChange}
										/>
										<Form.Label>Profil :</Form.Label>
										<Form.Control
											as="select"
											name="profil"
											value={values.profil || ""}
											onChange={handleChange}
										>
											<option></option>
											{this.state.profil}
										</Form.Control>
										<Form.Label className="required">Login :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="login"
											value={values.login || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">
											Mot de Passe :{" "}
										</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="password"
											value={values.password || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">Adresse :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="adresse"
											value={values.adresse || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">Code Postal :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="codepostal"
											value={values.codepostal || ""}
											onChange={handleChange}
											maxLength="5"
										/>
										<Form.Label className="required">Ville :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="ville"
											value={values.ville || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">Téléphone :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="telephone"
											value={values.telephone || ""}
											onChange={handleChange}
										/>
										<Form.Label>Fax :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="fax"
											value={values.fax || ""}
											onChange={handleChange}
										/>
										<Form.Label>Mail :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="mail"
											value={values.mail || ""}
											onChange={handleChange}
										/>
										<Form.Label>Profession :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="profession"
											value={values.profession || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">
											Type d'enlèvement :
										</Form.Label>
										<Form.Control
											as="select"
											required
											name="casUPS"
											value={values.casUPS}
											onChange={handleChange}
										>
											<option></option>
											{this.state.casUPS}
										</Form.Control>

										<Form.Label className="required">
											Format Etiquettes :
										</Form.Label>
										<Form.Control
											required
											as="select"
											name="formatEtiquettes"
											value={values.formatEtiquettes}
											onChange={handleChange}
										>
											<option></option>
											{this.state.formatEtiquettes}
										</Form.Control>

										<h2 className="mt-5">UPS</h2>
										<Form.Label>Type de service UPS :</Form.Label>
										<Form.Control
											as="select"
											name="serviceCode"
											value={values.serviceCode || ""}
											onChange={handleChange}
										>
											<option></option>
											{this.state.serviceCode}
										</Form.Control>
										<Form.Label>Heure limite de demande :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="heureLimite"
											value={values.heureLimite || ""}
											onChange={handleChange}
										/>
										<Form.Label>Nom UPS access point :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="nomPoint"
											value={values.nomPoint || ""}
											onChange={handleChange}
										/>
										<Form.Label>Adresse UPS access point :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="adressePoint"
											value={values.adressePoint || ""}
											onChange={handleChange}
										/>
										<Form.Label>Heure limite de dépôt :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="heurePoint"
											value={values.heurePoint || ""}
											onChange={handleChange}
										/>

										<Form.Label className="required">Agence :</Form.Label>
										{user_role == "Admin" ? (
											<Form.Control
												required
												as="select"
												name="agence"
												value={values.agence || ""}
												onChange={handleChange}
											>
												<option></option>
												{this.state.agences}
											</Form.Control>
										) : (
											<div>
												<Form.Control
													readOnly
													placeholder={this.state.data.agence_name}
												></Form.Control>
											</div>
										)}

										<Button
											size="sm"
											className="my-4"
											type="submit"
											disabled={isSubmitting}
										>
											Enregistrer
										</Button>
									</Form>
								)}
							</Formik>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default ModifyClient;
